<template>
  <div>
    <el-row >
      <el-button type="text" size="mini" @click="openItem" style="margin-right: 20px;">返回商品信息</el-button>
      名称：<el-input clearable size="mini" v-model="itemName" style="width: 200px;"></el-input> <el-button type="primary" size="mini" @click="getSkuData" >搜索</el-button>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-table   :data="skuData" ref="multipleTable" border  style="font-size: 14px; margin-left: 0px" class="exp"
                 :header-cell-style="{ background:'#F2F6FC',color:'#000'}" :default-expand-all="true" :row-style="{height: '0'}" :cell-style="{padding: '2px'}">
        <el-table-column type="expand" width="40">
          <template slot-scope="item">
            <el-table id="sub"  :show-header="false" :data="item.row.skus" ref=""  border style="width: 900px; font-size: 12px; margin-left: 80px"
                      :header-cell-style="{ background:'#EEEEEE',color:'#000'}"
                      :show-overflow-tooltip="true"  :row-style="{height: '0'}" :cell-style="{padding: '0px'}">
              <el-table-column prop="skuName" label="SKU名称" width="400px"></el-table-column>
              <el-table-column width="120px">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" style="margin-left: 20px" @click="openIngredient(scope.row)" >物料清单</el-button>
                </template>
              </el-table-column>
              <el-table-column width="160px">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" style="margin-left: 0px" @click="openSku(2, scope.row, item.row.itemId)" >修改</el-button>
                  <el-button type="danger" size="mini" style="margin-left: 0px" @click="deleteSku(scope.row)" >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>

        <el-table-column  label="序号" type="index" :index="indexMethod" width="60px" align="center"></el-table-column>
        <el-table-column  label="名称">
          <template slot-scope="scope">
            {{scope.row.title}} <el-button type="text" style="margin-left: 20px" @click="openSku(1, null, scope.row.itemId)">添加SKU</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[ 1, 2, 50, 100, 500, 1000, 5000]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>

    <el-dialog title="SKU信息" :visible.sync="showSku" :close-on-click-modal="false" width="550px" center>

      SKU名称：<el-input v-model="newSkuName" style="width: 400px;"></el-input>
      <el-checkbox v-model="chkContinuous" style="margin-left: 70px; margin-top: 20px">连续添加</el-checkbox>【提示：点确定后，不关闭本窗口】

      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveSku">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog title="物料清单" :visible.sync="showIngredient" :close-on-click-modal="false" width="800px" center>

        <el-tabs v-model="activeName" >

          <el-tab-pane label="物料清单" name="tabList">
            <el-row >
              名称：<el-input size="mini" v-model="mateName" style="width: 160px;"></el-input> <el-button type="primary" size="mini" @click="getIngredient" >搜索</el-button>
            </el-row>
            <el-row style="margin-top: 10px;">
              <el-table border style="font-size: 12px" ref="multipleTable" class="pd"
                        :data="ingredientData" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :cell-style="{padding: '0px'}">
                <el-table-column  label="序号"  type="index"  :index="indexMethod" width="50px"></el-table-column>
                <el-table-column prop="cateName" label="类别" width="120px"></el-table-column>
                <el-table-column prop="mateName" label="配件名称" width="160px"></el-table-column>
                <el-table-column prop="quantity" label="库存" width="70px"></el-table-column>
                <el-table-column prop="ratio" label="配比量" width="60px"></el-table-column>
                <el-table-column label="新配比" width="">
                  <template slot-scope="scope">
                    <el-input-number v-if="scope.row.ratio != null" size="mini" v-model="scope.row.newRatio" :min="1" label="描述文字" style="font-weight: bold; width: 140px"></el-input-number>

                    <div v-if="scope.row.ratio != scope.row.newRatio">
                      <span style="color: red">有变动</span>
                      <el-button type="text" size="mini" @click="updateRatio(scope.row)">保存</el-button>
                    </div>

                  </template>
                </el-table-column>
                <el-table-column width="60px">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="" style="margin-right: 20px">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="添加物料" name="tabAdd">
            <div style="height: 400px">
              <div style="float:left; height: 100%; width: 200px;border-right: #eeeeee solid 1px">
                <el-tree :data="treeData" :props="defaultProps" highlight-current="true"
                         :expand-on-click-node="false" :check-on-click-node="true" style=""
                         default-expand-all="true" @node-click="handleMenuClick"></el-tree>
              </div>
              <div style="float:left;margin-left: 10px; ">
                <!--https://www.jb51.net/article/248020.htm-->
                <el-row >
                  名称：<el-input size="mini" v-model="mateName" style="width: 300px;"></el-input> <el-button type="primary" size="mini" @click="getMateData" >搜索</el-button>
                </el-row>
                <el-row style="margin-top: 10px;">
                  <el-table border style="font-size: 12px" ref="multipleTable" class="pd"
                            :data="mateData" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :cell-style="{padding: '0px'}">
                    <el-table-column  label="序号"  type="index"  :index="indexMethod" width="60px"></el-table-column>
                    <el-table-column prop="cateName" label="类别" width="120px"></el-table-column>
                    <el-table-column prop="mateName" label="配件名称" width="160px"></el-table-column>
                    <el-table-column prop="quantity" label="库存" width="70px"></el-table-column>
                    <el-table-column width="">
                      <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="" style="margin-right: 20px" @click="addIngredient(scope.row)">加入清单</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="block" align="center">
                    <span class="demonstration"></span>
                    <el-pagination
                      @size-change="mateSizeChange"
                      @current-change="mateCurrentChange"
                      :current-page="pageObject.pageCurrent"
                      :page-sizes="[ 5, 10, 50, 100, 500]"
                      :page-size="matepageObject.pageSize"
                      layout="total, sizes, prev,  next, jumper"
                      :total="matepageObject.rowCount">
                    </el-pagination>
                  </div>
                </el-row>

              </div>
            </div>
          </el-tab-pane>

        </el-tabs>


       <span slot="footer" class="dialog-footer">
          <el-button type="" @click="showIngredient=false">关闭</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

  import {hideLoading, showLoading} from "../api/loading";
    export default {
        name: "JxcSku",
      data(){
          return{
            muCate:{
              id:'',
              label:'',
            },
            chkContinuous: false,
            activeName:'tabList',
            showSku:false,
            showIngredient:false,
            itemId:0,
            itemName:'',
            skuId:0,
            mateName:'',
            skuName:'',
            newSkuName: '',
            skuData:[{ id:1, title:'我是一个商品', skus:[{skuId:11,skuName:'我是一个SKU', quantity:20 },{skuId:13,skuName:'我是一个SKU', quantity:20 }]}],
            showMate:false,
            treeData:[],
            mateData:[],
            ingredientData:[],
            mateName:'',
            pageObject: {
              pageCurrent: 1,
              rowCount: 0,
              pageSize: 100,
            },
            matepageObject: {
              pageCurrent: 1,
              rowCount: 0,
              pageSize: 10,
            },
            defaultProps: {
              children: 'children',
              label: 'label'
            }
          }

      },
      methods:{
        indexMethod(index)
        {
          return index + 1;
        },
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getSkuData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getSkuData();
        },
        //改变pageSize
        mateSizeChange: function (val) {
          this.matepageObject.pageSize = val;
          this.getMateData();
        },
        //当前页面改变
        mateCurrentChange: function (val) {
          this.matepageObject.pageCurrent = val;
          this.getMateData();
        },
        handleMenuClick(data){
          this.muCate.id = data.id;
          this.muCate.label = data.label;
          this.getMateData();
        },
        openIngredient(row){
          this.showIngredient = true;
          this.skuId = row.skuId;
          console.log("skuid：" + this.skuId)
          this.getIngredient();
        },
        openItem(){
          this.$router.replace({name: 'JxcItem'});
        },
        //打开添加SKU
        openSku(flag, row, itemId){
          this.itemId = itemId;
          if(flag == 1){
            this.newSkuName = '';
            this.flag = 1;
          }else{
            this.newSkuName =  row.skuName;
            this.skuId = row.skuId
            this.flag = 2;
          }
          this.showSku = true;
        },
        saveSku(){
          let action = "";
          if(this.flag == 1){
            action = "addSku"
          }else{
            action = "updateSku"
          }
          let param={
            nick: storage.get('nick'),
            itemId: this.itemId,
            skuId: this.skuId,
            skuName: this.newSkuName,
          }
          $api.post("/jxc/" + action, param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1) {
              this.$message.success("操作已成功！");
              this.getSkuData();
              if(!this.chkContinuous){
                this.showSku = false;
              }
            }else{
              this.$message.error(dataResult.data);
            }
          })
        },
        deleteSku(row){
          let param={
            skuId: row.skuId,
          }
          $api.post("/jxc/deleteSku", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.$message.success("删除操作成功！")
              this.getSkuData();
            }else{
              this.$message.error('删除失败！');
            }
          })
        },
        //SKU列表
        getSkuData(){
          let param={
            nick: storage.get('nick'),
            title: this.itemName,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          }
          $api.post("/jxc/getSkuList", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.skuData = dataResult.data.sku;
              let pageObject = dataResult.data.pageObject;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
            }
          })
        },
        //是否可加入清单中去
        addIngredient(row){
          let param={
            nick: storage.get('nick'),
            skuId: this.skuId,
            mateId: row.mateId,
          }
          $api.post("/jxc/addIngredient", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.$message.success("成功加入物料清单");
              this.getIngredient();
            }else
              this.$message.error(dataResult.data);
          })
        },
        //修改配料配比
        updateRatio(row){
          let param={
            id: row.id,
            ratio: row.newRatio,
          }
          $api.post("/jxc/updateRatio", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.$message.success("更新配比成功");
              this.getIngredient();
            }else
              this.$message.error(dataResult.data);
          })
        },
        getTree(){
          let param = {
            nick: storage.get('nick')
          }
          $api.post("/jxc/getTree", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.treeData = dataResult.data;
            }
          })
        },
        getIngredient(){
          let param={
            nick:storage.get('nick'),
            skuId: this.skuId,
            mateName: '',
          }
          $api.post("/jxc/getIngredient", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.ingredientData= dataResult.data.ingredient;
            }else {
              this.$message.error(dataResult.message);
            }
          })
        },
        getMateData(){
          let param={
            nick:storage.get('nick'),
            cateId: this.muCate.id,
            mateName: this.mateName,
            pageCurrent: this.matepageObject.pageCurrent,
            rowCount: this.matepageObject.rowCount,
            pageSize: this.matepageObject.pageSize,
          }
          $api.post("/jxc/getMate", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.mateData= dataResult.data.mate;

              let pageObject = dataResult.data.pageObject;;
              this.matepageObject.rowCount = pageObject.rowCount;
              this.matepageObject.pageSize = pageObject.pageSize;
            }else {
              this.$message.error(dataResult.message);
            }
          })
        },
      },
      mounted(){
        this.getTree();
        this.getMateData();
        this.getSkuData();
      }
    }
</script>

<style  scoped>

  /*.exp /deep/ .el-table__expanded-cell[class*=cell]{*/
      /*padding: 10px 20px;*/
      /*background-color: transparent;*/
    /*}*/
  /*.pd /deep/ .el-table td{*/
    /*padding: 0px 0px;*/
  /*}*/



</style>



// WEBPACK FOOTER //
// src/jxc/JxcSku.vue